// Shared MediaRecorder mime-type picker — used by both ReadingMode (timed
// reading + auto-record) and RecordingMode (Module 9 free-form recording).
export function pickMime() {
  const candidates = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4"];
  for (const mm of candidates) {
    if (typeof MediaRecorder !== "undefined" && MediaRecorder.isTypeSupported(mm)) return mm;
  }
  return "audio/webm";
}
